import { ColumnDefWithTooltip } from "src/components/Table/Table";
import { ColumnId } from "./constants";

type Row = { schoolForm: { lotteryPosition: number | null } | null };

export const buildLotteryPositionColumnDef = <
  T extends Row
>(): ColumnDefWithTooltip<T> => ({
  id: ColumnId.LotteryPosition,
  header: "Lottery Position",
  accessorFn: (row: T) => row.schoolForm?.lotteryPosition,
  enableSorting: false,
});
